<template>
  <div class="legend-container">
    <div :style="{ color, 'border-color': color }" class="budget-range-slider-legend-input d-flex justify-center align-center">
      <input v-model.number="valueModel" :disabled="disabled" type="number" />
      <span>%</span>
    </div>
    <p>{{ legend }}</p>
  </div>
</template>

<script>
export default {
  name: 'BudgetRangeSliderLegendInput',
  props: {
    color: {
      type: String,
      required: true,
    },
    legend: {
      type: String,
      required: true,
    },
    value: [Number, String],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      },
    },
  },
  watch: {
    valueModel() {
      if (this.valueModel < 0 || !this.valueModel) this.valueModel = 0
      else if (this.valueModel > 100) this.valueModel = 100
      this.$emit('input')
    },
  },
}
</script>

<style lang="scss" scoped>
.legend-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  & p {
    margin: 0;
    color: $cinza-d10;
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
  }
}

.budget-range-slider-legend-input {
  border: 1px solid;
  border-radius: 4px;
  padding: 8px 15px;
  width: 68px;
  box-shadow: none !important;

  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  & input,
  span {
    font-size: 14px;
    font-weight: bold;
    line-height: 120%;
    text-align: center;
  }
  & input {
    max-width: calc(100% - 5px);
    outline: none;
  }
}
</style>
